import React from 'react'
import classnames from 'classnames/bind'
import { ColorNames } from '../../../constants/colorVars'
import Icon from '../icon'
import InfoPill, { InfoPillProps } from '../infoPill'
import LabelValue, { LabelValueProps } from '../labelValue'
import CardContainer from '../cardContainer'
import styles from './styles.scss'

const cx = classnames.bind(styles)

export interface TermProps
  extends Pick<
      InfoPillProps,
      | 'iconName'
      | 'iconColor'
      | 'icon'
      | 'elmId'
      | 'backgroundColor'
      | 'foregroundColor'
      | 'className'
      | 'style'
      | 'extraPadding'
    >,
    Omit<LabelValueProps, 'level'> {
  withCardContainer?: boolean
  isExpanded?: boolean
}

const Term: React.FC<TermProps> = ({
  iconName,
  iconColor = ColorNames.Success,
  icon,
  elmId = 'term',
  backgroundColor = ColorNames.Transparent,
  foregroundColor = ColorNames.Gray,
  className,
  style,
  extraPadding,
  label,
  value,
  tooltipContent,
  isMoneyValue,
  withCardContainer,
  isExpanded,
}) => {
  const newIcon = icon || (
    <Icon
      name={iconName || 'check'}
      color={iconColor}
      style={{ fontSize: 24 }}
      iconStyle='light'
      fitted
      elmId={`${elmId}-icon`}
    />
  )

  const newLabel = (
    <LabelValue
      label={label || ''}
      value={value || ''}
      isMoneyValue={isMoneyValue}
      tooltipContent={tooltipContent}
      tooltipIconStyle='regular'
      level={4}
      elmId={elmId}
    />
  )

  const renderPill = () => (
    <InfoPill
      icon={newIcon}
      elmId={`${elmId}-info-pill`}
      size='medium'
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      className={cx('term-pill', className)}
      style={style}
      extraPadding={extraPadding}
      label={newLabel}
    />
  )

  return withCardContainer ? (
    <CardContainer
      padding='extra-small'
      borderRadius='extra-small'
      dropShadow='small'
      className={cx('term-card', { expanded: isExpanded })}
      elmId={`${elmId}-card-container`}
    >
      {renderPill()}
    </CardContainer>
  ) : (
    renderPill()
  )
}

export default Term
